import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const CareTeamFilled: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 16)} fill="none">
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM6.87266 5H9.12266V6.87734H11V9.12734H9.12266V11H6.87266V9.12734H5V6.87734H6.87266V5Z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(CareTeamFilled);
